export const SSOEvents = {
  appleLogin: 'page__apple_login_button_click',
  google: {
    click: 'page__google_login_button_click',
    success: 'page__google_login_button_success',
    error: 'page__google_login_button_error'
  },
}
